import { mapState, mapActions, mapGetters } from 'vuex';
import { publicApi } from '@/utils/api';

export const read_mixin = {
  computed: {
    ...mapGetters(['is_viewer']),
    ...mapState('report_list', ['view_mode']),
    ...mapGetters('report_list', ['gri_ver', 'current_report_code'])
  },
  methods: {
    ...mapActions('gri2021_report_view', ['readReportContents', 'checkTopicIsMaterial']),
    // ...mapActions('report_contents', { readReportContentsLegacy: 'readReportContents' }),
    ...mapActions('data_tables', ['readDataTableList']),
    ...mapActions('documents', ['readDocumentList']),
    ...mapActions('business_cases', ['readBusinessCaseList']),
    ...mapActions('report_indicators', ['readSelectedTopics']),
    ...mapActions('assurance', [
      'readAssuranceStatusByReportCode',
      'readAssuranceListByReportCode'
    ]),
    ...mapActions('report_indicators', ['readReportTopics', 'readReportIndicators']),
    ...mapActions('report_list', ['readAllReportListForViewer', 'checkReportPublish']),
    ...mapActions('report_contents', ['get_theme_info']),

    readReport(report_code) {
      // this.readReportContentsLegacy({ report_code: report_code, editor_mode: this.view_mode === 'editor' })
      this.readReportContents({
        report_code: report_code,
        editor_mode: this.view_mode === 'editor'
      });
      this.checkTopicIsMaterial({
        report_code: report_code,
        editor_mode: this.view_mode === 'editor'
      });
    },

    readErtContent(report_code) {
      this.readDataTableList({ report_code: report_code });
      this.readDocumentList({ report_code: report_code, viewer: this.view_mode === 'viewer' });
      this.readBusinessCaseList({ report_code: report_code }); // VUE_APP_REPORT_CODE 빌드 시 스토리보드형식이면 사실 필요 없음.
    },

    readLegacyReport(report_code) {
      this.readSelectedTopics({ report_code: report_code });
      this.readReportTopics({ report_code: report_code });
      this.readReportIndicators({ report_code: report_code });
      // this.readAssuranceListByReportCode({ report_code: report_code });
    },
    readAssurance(report_code) {
      this.readAssuranceListByReportCode({ report_code: report_code });
      this.readAssuranceStatusByReportCode({ report_code: report_code });
    },

    async initializeCSS() {
      const beforeStyledSheet = document.getElementsByClassName('customized-css-styling');
      if (beforeStyledSheet.length > 0) {
        for (const element of beforeStyledSheet) {
          element.remove();
        }
      }

      const result = await publicApi.post('/custom_theme/add_custom_theme', {
        report_code: this.current_report_code
      });

      const styleElement = document.createElement('style');
      styleElement.classList.add('customized-css-styling');
      styleElement.innerHTML = result?.data?.css_content || '';
      document.head.appendChild(styleElement);
    },

    async readAll(parsed_report_code) {
      await this.checkReportPublish(parsed_report_code);
      await this.get_theme_info({ report_code: parsed_report_code });
      await this.readAllReportListForViewer({ report_code: this.current_report_code });

      if (!this.$route.path.includes('/a')) {
        await this.readReport(this.current_report_code);
        await this.readAssurance(this.current_report_code);
        await this.readErtContent(this.current_report_code);
        await this.readLegacyReport(this.current_report_code);
      }

      await this.get_theme_info({ report_code: this.current_report_code }); // backup theme info
      await this.initializeCSS();
    }
  }
};
